import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    headNav: '',
    aboutNav: '',
    contactNav: '',
    newsNav: '',
    // 初始值设为大于 960，避免首屏短暂显示移动端分支
    screenWidth: document.documentElement.clientWidth || 1920
  },
  mutations: {
    changeHeadNav(state, val) {
      state.headNav = val
    },
    changeAboutNav(state, val) {
      state.aboutNav = val
    },
    changeContactNav(state, val) {
      state.contactNav = val
    },
    changeNewsNav(state, val) {
      state.newsNav = val
    },
    changeScreenWidth(state, val) {
      state.screenWidth = val
    }
  },
  actions: {},
  modules: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js